'use client';

export function LibraryOfflineCard({ onRetry }: { onRetry?: () => void }) {
  return (
    <div className="mx-auto mt-12 max-w-md rounded-2xl border border-amber-200 bg-amber-50 p-8 text-center shadow-sm">
      <div className="mb-4 text-7xl" aria-hidden>📚💤</div>
      <h2 className="mb-2 text-xl font-semibold text-amber-900">
        Библиотека прилегла отдохнуть
      </h2>
      <p className="mb-1 text-sm text-amber-800">
        Сервер сейчас недоступен. Мы уже бежим её будить!
      </p>
      <p className="mb-6 text-xs text-amber-700">
        Вы знаете к кому обратиться...
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="rounded-lg bg-amber-600 px-5 py-2 text-sm font-medium text-white transition hover:bg-amber-700 active:bg-amber-800"
        >
          Попробовать снова
        </button>
      )}
    </div>
  );
}
